
import {
  HttpClient, HttpParams} from '@angular/common/http';
import { HttpClientBaseService } from './base/httpClientBase.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BolsaVacaciones } from '../models/bolsaVacaciones.model';
import { IServiceBase } from './base/IServiceBase';
import { PageList } from '../models/pageList.model';
import { PeriodosBolsaVacacionesModel } from '../models/periodosBolsaVacaciones.model';
import { A3LEmployeeAdvance } from '../models/a3LEmployeeAdvance.model';
import { BolsaVacacionesLiquidacion } from '../models/bolsaVacacionesLiquidacion.model';
import { SolicitudBolsaVacaciones } from '../models/SolicitudBolsaVacaciones.model';

@Injectable()
export class BolsaVacacionesService extends HttpClientBaseService implements IServiceBase<BolsaVacaciones> {
  constructor(_http: HttpClient) {
    super(_http, 'holidaysExtraPay/','', false);
  }
  getAllModels(parentId?: any, params?: HttpParams): Observable<BolsaVacaciones[]> {
    return super.getAll<BolsaVacaciones[]>();
  }
  getAllByCompanyAndYear(companyCode: number, year: number): Observable<BolsaVacaciones[]> {
    return this.http.get<BolsaVacaciones[]>(`${super.getUrl()}company/${companyCode}/year/${year}`);
  }

  getPeriodsByCompanyAndYear(companyCode: number, year: number): Observable<PeriodosBolsaVacacionesModel[]> {
    return this.http.get<PeriodosBolsaVacacionesModel[]>(`${super.getUrl()}company/${companyCode}/year/${year}/periods`);
  }

  getAllByCompanyEmployeeAndYear(companyCode: number, employeeCode: string, year: number): Observable<BolsaVacaciones> {
    return this.http.get<BolsaVacaciones>(`${super.getUrl()}company/${companyCode}/employee/${employeeCode}/year/${year}`);
  }

  getPagedModels(parentId?: any, params?: HttpParams): Observable<PageList<BolsaVacaciones>> {
    throw new Error('Method not implemented.');
  }
  getModel(id: any, parentId?: any): Observable<BolsaVacaciones> {
    return super.getSingle<BolsaVacaciones>(id);
  }

  getAdvances(companyCode: string, employeeCode: string, year: number): Observable<A3LEmployeeAdvance[]> {
    return this.http.get<A3LEmployeeAdvance[]>(`${super.getUrl()}company/${companyCode}/employee/${employeeCode}/year/${year}/advances`);
  }

  getToLiquidate(companyCode: number, year: number, primerPeriodo: boolean): Observable<BolsaVacacionesLiquidacion[]> {
    return this.http.get<BolsaVacacionesLiquidacion[]>(`${super.getUrl()}company/${companyCode}/year/${year}/toliquidate?primerPeriodo=${primerPeriodo}`);
  }

  liquidate(companyCode: number, year: number, solicitudes: SolicitudBolsaVacaciones[]): Observable<BolsaVacacionesLiquidacion[]> {
    return this.http.post<any>(`${super.getUrl()}company/${companyCode}/year/${year}/liquidate`, solicitudes);
  }

}
